import { useStaticQuery, graphql } from 'gatsby'

export const useGetStats = () => {
  const data = useStaticQuery(graphql`query StatsQuery {
  published: allMdx(filter: {frontmatter: {draft: {ne: false}}}) {
    totalCount
    words: sum(field: {fields: {timeToRead: {words: SELECT}}})
    time: sum(field: {fields: {timeToRead: {time: SELECT}}})
    mins: sum(field: {fields: {timeToRead: {minutes: SELECT}}})
  }
  unpublished: allMdx(filter: {frontmatter: {draft: {eq: true}}}) {
    totalCount
    words: sum(field: {fields: {timeToRead: {words: SELECT}}})
    time: sum(field: {fields: {timeToRead: {time: SELECT}}})
    mins: sum(field: {fields: {timeToRead: {minutes: SELECT}}})
  }
}`);
  //const multiplier = 10.8;
  const multiplier = 16.8;

  return {
    published: {
      totalCount: data.published.totalCount.toLocaleString(),
      words: data.published.words ? data.published.words.toLocaleString() : 0,
      time: data.published.time ?? 0,
      mins: data.published.mins ? Math.round(data.published.mins).toLocaleString() : 0,
      minsToWrite: Math.round((data.published.words * multiplier) / 60).toLocaleString(),
      hrsToWrite: Math.round((data.published.words * multiplier) / 60/60).toLocaleString(),
    },
    unpublished: {
      totalCount: data.unpublished.totalCount.toLocaleString(),
      words: data.unpublished.words ? data.unpublished.words.toLocaleString() : 0,
      time: data.unpublished.time ?? 0,
      mins: data.unpublished.mins ? Math.round(data.unpublished.mins).toLocaleString() : 0,
      minsToWrite: Math.round((data.unpublished.words * multiplier) / 60).toLocaleString(),
      hrsToWrite: Math.round((data.unpublished.words * multiplier) / 60/60).toLocaleString(),
    }
  }
}
